import { isJSXElement } from "@utils/common";
import React from "react";

export interface RatingHeaderDataProps {
    title: string | JSX.Element;
}

export interface RatingComparisonDataProps {
    featureName: string | JSX.Element;
    gallabox: number;
    competitor: number;
}

interface RatingComparisonProps {
    headerData: RatingHeaderDataProps[];
    comparisonData: RatingComparisonDataProps[];
}

const RatingComparison: React.FC<RatingComparisonProps> = (props) => {
    const { headerData, comparisonData } = props;
    const [g2Rating, gallabox, competitor] = headerData;
    return (
        <>
            <div className="lg:block md:block hidden">
                <section className="grid grid-cols-3 gap-x-8 gap-y-6">
                    {headerData.map((item, index) => {
                        return (
                            <div key={index} className="flex items-center justify-start py-5">
                                {isJSXElement(item.title) ? item.title : <h6 className="text-2xl font-medium text-gray-700">{item.title}</h6>}
                            </div>
                        );
                    })}
                    {comparisonData.map((contentlist, index) => {
                        return (
                            <React.Fragment key={index}>
                                <p className="text-xl text-gray-600 font-medium">{contentlist.featureName}</p>
                                <div className="flex items-center mb-4">
                                    <input readOnly type="range" min="0" max="10" step="0.01" value={contentlist.gallabox} className="rating-gallabox-range w-72" />
                                    <p className="text-base text-gray-600 font-normal lg:px-6 px-2">{contentlist.gallabox.toFixed(1)}</p>
                                </div>
                                <div className="flex items-center mb-4">
                                    <input readOnly type="range" min="0" max="10" step="0.01" value={contentlist.competitor} className="rating-competitor-range w-72" />
                                    <p className="text-base text-gray-600 font-normal lg:px-6 px-2">{contentlist.competitor.toFixed(1)}</p>
                                </div>
                            </React.Fragment>
                        );
                    })}
                </section>
            </div>
            <section className="lg:hidden md:hidden block">
                <div className="flex flex-col items-center gap-3 mb-5">
                    {isJSXElement(g2Rating.title) ? g2Rating.title : <h6 className="text-2xl font-medium text-gray-700">{g2Rating.title}</h6>}
                    <div className="flex items-center gap-3">
                        {isJSXElement(gallabox.title) ? gallabox.title : <h6 className="flex-shrink-0 text-2xl font-medium text-gray-700">{gallabox.title}</h6>}
                        <span className="text-base font-semibold text-gray-700">vs</span>
                        {isJSXElement(competitor.title) ? competitor.title : <h6 className="text-2xl font-medium text-gray-700">{competitor.title}</h6>}
                    </div>
                </div>

                <section className="w-full lg:mx-auto mx-4 grid grid-cols-1 gap-y-1.5">
                    {comparisonData.map((contentlist, index) => {
                        return (
                            <React.Fragment key={index}>
                                <p className="text-xl text-gray-600 font-normal">{contentlist.featureName}</p>
                                <div className="flex items-center mb-0">
                                    <input
                                        readOnly
                                        type="range"
                                        min="0"
                                        max="10"
                                        step="0.01"
                                        value={contentlist.gallabox}
                                        className="rating-gallabox-range"
                                        style={{ width: "calc(100% - 75px)" }}
                                    />
                                    <p className="text-base text-gray-600 font-normal px-4">{contentlist.gallabox.toFixed(1)}</p>
                                </div>
                                <div className="flex items-center mb-5">
                                    <input
                                        readOnly
                                        type="range"
                                        min="0"
                                        max="10"
                                        step="0.01"
                                        value={contentlist.competitor}
                                        className="rating-competitor-range"
                                        style={{ width: "calc(100% - 75px)" }}
                                    />
                                    <p className="text-base text-gray-600 font-normal px-4">{contentlist.competitor.toFixed(1)}</p>
                                </div>
                            </React.Fragment>
                        );
                    })}
                </section>
            </section>
        </>
    );
};

export default RatingComparison;
